/**
 * App root — mounts the provider stack.
 *
 * Phase: 3 (router introduced), 4+ (admin routes added inside router.tsx)
 *
 * Wraps the router in:
 *   - MantineProvider (theme + CSS variables)
 *   - QueryClientProvider (TanStack Query cache)
 */

import "@mantine/core/styles.css";

import { MantineProvider } from "@mantine/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  return (
    <MantineProvider defaultColorScheme="light">
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </MantineProvider>
  );
}
